import { useDataModel } from '@thd-nucleus/data-sources';
import { heightRE, lengthRE, widthRE } from '../constants';

export const useOrderSample = ({ itemId, storeId, zipCode }) => {
  const productOptions = {
    skip: storeId === '8119',
    ssr: false,
    variables: {
      itemId
    },
  };

  const { data: productData, loading } = useDataModel('clientOnlyProduct', productOptions);

  const sampleId = productData?.product?.identifiers?.sampleId;
  const isSuperSku = productData?.product?.identifiers?.isSuperSku;
  const parentId = productData?.product?.identifiers?.parentId;

  const sampleProductOptions = {
    skip: storeId === '8119' || !sampleId || !zipCode,
    ssr: false,
    variables: {
      itemId: sampleId,
      storeId,
      zipCode
    },
  };
  const sample = useDataModel('sampleProduct', sampleProductOptions);

  let dimensionText = '';
  let price;

  const product = sample?.data?.product;

  if (product?.specificationGroup) {
    const getDimensionText = (dimension) => {
      const specExt = dimension?.specName?.match(/\(([^)]+)\)/);
      const specName = specExt.length > 0 ? specExt[1] : '';
      return `${(dimension.specValue.match(/\d+/g) || [])[0]} ${specName}`;
    };

    const { specifications: dimensions } = product.specificationGroup
      .find((spec) => spec.specTitle === 'Dimensions') || {};

    const length = (dimensions || []).find(({ specName }) => lengthRE.test(specName) || heightRE.test(specName));
    const lengthText = length ? getDimensionText(length) : '';
    const width = (dimensions || []).find(({ specName }) => widthRE.test(specName));
    const widthText = width ? getDimensionText(width) : '';

    if (length && width) {
      dimensionText = `${lengthText} x ${widthText}`;
    }

    if (product?.pricing) {
      price = product.pricing.value;
    }
  }
  const hasSample = !!sampleId;

  return {
    data: {
      dimensionText, hasSample, isSuperSku, parentId, price, product, sampleId
    },
    loading: loading || sample?.loading
  };
};
